// Import services
import { SegmentHttpService } from 'services/http';
import { SegmentById } from 'types';

const getSegmentClientCount = () => {
    const getSegmentClientCountRequest = SegmentHttpService.getSegmentClientCount();
    return {
        request: (segmentId, callBack, errorCallBack, pointInTime?: Nullable<string>) => {
            getSegmentClientCountRequest
                .request({ segmentId, pointInTime })
                .then((response) => {
                    const { HasError, AlertMessage, Data } = response;
                    if (!HasError) {
                        callBack(Data);
                    } else {
                        errorCallBack(AlertMessage);
                    }
                })
                .catch((error) => {
                    // eslint-disable-next-line no-console
                    console.log(error);
                    // TODO: need add error handling
                });
        },
        cancel: getSegmentClientCountRequest.cancel,
    };
};

const getCampaignsBySegment = () => {
    const getCampaignsBySegmentRequest = SegmentHttpService.getCampaignsBySegment();
    return {
        request: (segmentId, callBack, errorCallBack, pointInTime?: Nullable<string>) => {
            getCampaignsBySegmentRequest
                .request({ segmentId, pointInTime })
                .then((response) => {
                    const { HasError, AlertMessage, Data } = response;
                    if (!HasError) {
                        callBack(Data);
                    } else {
                        errorCallBack(AlertMessage);
                    }
                })
                .catch((error) => {
                    // eslint-disable-next-line no-console
                    console.log(error);
                    // TODO: need add error handling
                });
        },
        cancel: getCampaignsBySegmentRequest.cancel,
    };
};

const getStaticSegmentTop200Client = () => {
    const getStaticSegmentTop200ClientRequest = SegmentHttpService.getStaticSegmentTop200Client();
    return {
        request: (segmentId, callBack, errorCallBack: (message?: Nullable<string>) => void) => {
            getStaticSegmentTop200ClientRequest
                .request(null, { segmentId })
                .then((response) => {
                    const { HasError, Data, AlertMessage } = response;
                    if (!HasError) {
                        const resultData = Data?.Data?.map((elem) =>
                            Data?.Columns.reduce((accumulator, element, index) => {
                                accumulator[element.ColumnName] = elem[index];
                                return accumulator;
                            }, {}),
                        );

                        callBack({
                            Data: resultData,
                            Columns: Data?.Columns,
                        });
                    } else {
                        errorCallBack(AlertMessage);
                    }
                })
                .catch((error) => {
                    // eslint-disable-next-line no-console
                    console.log(error);
                });
        },
        cancel: getStaticSegmentTop200ClientRequest.cancel,
    };
};

const getSegmentById = () => {
    const getSegmentByIdRequest = SegmentHttpService.getSegmentById();
    return {
        request: (
            segmentId: number | string,
            callBack: (data: SegmentById) => void,
            errorCallBack: (message: string) => void,
            pointInTime?: Nullable<string>,
        ) => {
            getSegmentByIdRequest
                .request({ segmentId, pointInTime })
                .then((response) => {
                    const { HasError, AlertMessage, Data } = response as AnyObject;
                    if (!HasError) {
                        callBack(Data as SegmentById);
                    } else {
                        errorCallBack(AlertMessage);
                    }
                })
                .catch((error) => {
                    // eslint-disable-next-line no-console
                    console.log(error.message);
                    // TODO: need add error handling
                });
        },
        cancel: getSegmentByIdRequest.cancel,
    };
};

const getNonCustomerSegmentPreview = () => {
    const getNonCustomerSegmentPreviewRequest = SegmentHttpService.getNonCustomerSegmentPreview();
    return {
        request: (segmentId, callBack, errorCallBack) => {
            getNonCustomerSegmentPreviewRequest
                .request({ segmentId })
                .then((response) => {
                    const { HasError, AlertMessage, Data } = response;
                    if (!HasError) {
                        const resultData = Data?.Data?.map((elem, _index) =>
                            Data?.Columns.reduce((accumulator, element, index) => {
                                accumulator[element.ColumnName] = elem[index];
                                return accumulator;
                            }, {}),
                        );

                        callBack({
                            Data: resultData,
                            Columns: Data?.Columns,
                            Name: Data.Name,
                            SegmentId: Data.SegmentId,
                        });
                    } else {
                        errorCallBack(AlertMessage);
                    }
                })
                .catch((error) => {
                    // eslint-disable-next-line no-console
                    console.log(error.message);
                    // TODO: need add error handling
                });
        },
        cancel: getNonCustomerSegmentPreviewRequest.cancel,
    };
};

export {
    getSegmentClientCount,
    getCampaignsBySegment,
    getStaticSegmentTop200Client,
    getSegmentById,
    getNonCustomerSegmentPreview,
};
